import { GraphQlClient, Storage, Auth } from '@intelipost-js/secure-providers';

export default {
  getNotifications({ commit, state }) {
    const notifications = Storage.get(state.storageKey, 'session');

    if (notifications) {
      commit('setNotifications', notifications);
      return Promise.resolve(notifications);
    }

    return GraphQlClient.query(`
      query {
        notifications {
          id
          type
          title
          message
          link
        }
      }`)
      .then((res) => {
        commit('setNotifications', res.data.notifications);
        return res;
      })
      .catch(() => Promise.resolve());
  },
  confirmReadNotification({ commit }, notification) {
    commit('toggleLoading', true);

    const { email } = Auth.getUser();
    const params = {
      id: notification.id,
      email_user: email,
    };

    return GraphQlClient.mutation(`
      mutation ($id: ID!, $email_user: String!){
        confirmReadNotification(id: $id, email_user: $email_user) {
          id
        }
      }`, params)
      .then((res) => {
        commit('toggleLoading', false);
        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        throw err;
      });
  },
};



// WEBPACK FOOTER //
// ./src/stores/notifications/actions.js